export default {
    methods: {
        handleErrors(error) {
            error = error.response;
            if (error.status === 404) {
                this.$router.push({
                    name: "error_404",
                    params: { lang: this.$store.getters.locale }
                });
            }
            if (error.status === 401) {
                this.$store.commit("newMessage", {
                    show: true,
                    type: "error",
                    messageTitle: this.$store.getters.t("error"),
                    message: this.$store.getters.t("authentication_fails")
                  });
            }
            if (error.status === 403) {
                this.$store.commit("newMessage", {
                    show: true,
                    type: "error",
                    messageTitle: this.$store.getters.t("error"),
                    message: this.$store.getters.t("invalid data")
                });
            }
            if (error.status === 422) {
                this.$store.commit("newMessage", {
                    show: true,
                    type: "attention",
                    messageTitle: this.$store.getters.t("attention"),
                    message: this.$store.getters.t("invalid field")
                });
            }
            if (error.status === 500) {
                this.$store.commit("newMessage", {
                    show: true,
                    type: "error",
                    messageTitle: this.$store.getters.t("error"),
                    message: this.$store.getters.t("server_error")
                });
            }
        }
    }
};



// WEBPACK FOOTER //
// ./resources/js/mixins/error.js